// src/api/service.js
import API from "./axiosInstance";

// ✅ Token Logic: Har request ke header mein Token auto-inject hoga
API.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// 🔥 LOGIN DIVISION
export const loginAdmin = async (email, password) => {
  try {
    const res = await API.post("/login", { email, password });
    if (res.data.success && res.data.token) {
      localStorage.setItem("token", res.data.token);
      API.defaults.headers.common["Authorization"] = `Bearer ${res.data.token}`;
      
    }
    return res.data;
  } catch (err) {
    console.error("Login Error:", err.response?.data);
    throw err.response?.data || { message: "Login failed" };
  }
};

// 📂 EXCEL UPLOAD
export const uploadExcelData = async (json) => {
  try {
    const res = await API.post("/save-excel", { data: json });
    return res.data;
  } catch (err) {
    console.error("Excel Upload Error:", err);
    throw err;
  }
};

// 📩 BULK EMAILS (OFFERS / CERTIFICATES)
export const sendBulkEmails = async (filteredData, mode) => {
  try {
    const endpoint = mode === "offer" ? "/send-offers" : "/send-certificates";
    const res = await API.post(endpoint, { data: filteredData });
    return res.data;
  } catch (err) {
    console.error("Bulk Email Error:", err);
    throw err;
  }
};

// 📄 SINGLE PDF DOWNLOAD
export const downloadStudentPDF = async (student, mode) => {
  try {
    const res = await API.post(
      "/download-pdf",
      { student, mode },
      { responseType: "blob" }
    );
    return res.data;
  } catch (err) {
    console.error("PDF Download Error:", err);
    throw err;
  }
};

// 🗜️ BULK ZIP DOWNLOAD
export const downloadCertificatesZip = async (filteredData) => {
  try {
    const res = await API.post(
      "/download-zip",
      { data: filteredData },
      { responseType: "blob" }
    );
    return res.data;
  } catch (err) {
    console.error("ZIP Download Error:", err);
    throw err;
  }
};

// 🚪 LOGOUT UTILITY - Pure File mein sirf EK hi baar rahega ab!
export const logoutAdmin = () => {
  localStorage.removeItem("token");
  window.location.href = "/login";
};